import { render, staticRenderFns } from "./ModalRejeitarPedido.vue?vue&type=template&id=0fe445b0&scoped=true&"
import script from "./ModalRejeitarPedido.vue?vue&type=script&lang=js&"
export * from "./ModalRejeitarPedido.vue?vue&type=script&lang=js&"
import style0 from "./ModalRejeitarPedido.vue?vue&type=style&index=0&id=0fe445b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe445b0",
  null
  
)

export default component.exports